const Sharing = () => {
  return (
    <div className="sharing options">
      <div>
        <h2>Share your bookmarks</h2>
        <p>Easily share your bookmarks and collections with others. Create a shareable link that you can send at the click of a button.</p>
        <button>More Info</button>
      </div>
    </div>
  )
}

export default Sharing